// extracted by mini-css-extract-plugin
export default {"Root":"Block_Root__AJkD1","Broadcast":"Block_Broadcast__N-c+D"};